import i18n from "@/i18n";
import { AppData, ResturantData } from "@/types/globalTypes";
import { useEffect, useState } from "react";
import { IoMdClose } from "react-icons/io";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import axios from "axios";
import { useSelector } from "react-redux";
import useLockBodyScroll from "@/hooks/useLockBodyScroll";

type LoyaltyPointsAppProps = {
  app: AppData;
  isPending: boolean;
  installApp: (appName: string) => void;
  uninstallApp: (appName: string) => void;
};

function LoyaltyPointsApp({
  app,
  isPending,
  installApp,
  uninstallApp,
}: LoyaltyPointsAppProps) {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const { t } = useTranslation();
  const [pointsPerRiyal, setPointsPerRiyal] = useState('');
  const [discountPoints, setDiscountPoints] = useState('');
  const [discountRiyal, setDiscountRiyal] = useState('');
  const [initialData, setInitialData] = useState(null);
  const token = useSelector((state: { auth: { token: string } }) => state.auth.token)
  const baseUrl = import.meta.env.VITE_BASE_URL

  const ResturantData = useSelector(
    (state: { resturant: { resturantData: ResturantData } }) =>
      state.resturant.resturantData,
  );

  const WithoutPlan = ResturantData?.subscription === null
  useLockBodyScroll(isModalOpen);
  console.log(initialData)
  useEffect(() => {
    const fetchLoyaltyPoints = async () => {
      try {
        const res = await axios.get(`${baseUrl}/api/dashboard/loyalty/points`, {
          headers: {
            Authorization: token,
          },
        });

        const data = res.data;
        setInitialData(data);

        setPointsPerRiyal(data?.earnedPointsFactor?.toString() || '');
        setDiscountPoints(data?.usedPointsFactor?.points?.toString() || '');
        setDiscountRiyal(data?.usedPointsFactor?.amount?.toString() || '');
      } catch {
        toast.error(t("loyaltyPointsApp.error"));
      }
    };

    if (isModalOpen) {
      fetchLoyaltyPoints();
    }
  }, [isModalOpen, baseUrl, token, t]);

  const submit = async () => {
    const payload = {
      earnedPointsFactor: Number(pointsPerRiyal),
      usedPointsFactor: {
        amount: Number(discountRiyal),
        points: Number(discountPoints),
      },
    };

    try {
      await axios.put(`${baseUrl}/api/dashboard/loyalty/points`, payload, {
        headers: {
          Authorization: token,
        },
      });

      toast.success(t("loyaltyPointsApp.success"));
      setIsModalOpen(false);
      setPointsPerRiyal('');
      setDiscountPoints('');
      setDiscountRiyal('');
    } catch {
      toast.error(t("loyaltyPointsApp.error"));
    }
  };



  return (
    <>
      <div
        key={app.name}
        className="whatsapp-card relative flex flex-col gap-5 overflow-hidden rounded-lg border bg-white p-5"
      >
        <div className="card-head flex items-center justify-between">
          {/* image */}
          <div className="w-14">
            <img src={app.image} alt="app image" className="w-full" />
          </div>

          {/* badge */}
          {WithoutPlan ? (
            <span
              className={`absolute top-[20px] w-[8rem] bg-sidebar py-1 text-center font-semibold text-skyblue ${i18n.language === "ar" ? "end-[-30px] rotate-[-45deg]" : "end-[-30px] -rotate-[-45deg]"
                }`}
            >
              {t("subscribtionSettings.pro")}
            </span>
          ) : !app.available ? (
            <span
              className={`absolute top-[20px] w-[8rem] bg-[#ffc62a] py-1 text-center font-semibold text-[#907017] ${i18n.language === "ar" ? "end-[-30px] rotate-[-45deg]" : "end-[-30px] -rotate-[-45deg]"
                }`}
            >
              {t("apps.soon")}
            </span>
          ) : app.installed ? (
            <span
              className={`absolute top-[20px] w-[8rem] bg-green-400 py-1 text-center font-semibold text-green-700 ${i18n.language === "ar" ? "end-[-30px] rotate-[-45deg]" : "end-[-30px] -rotate-[-45deg]"
                }`}
            >
              {t("apps.active")}
            </span>
          ) : (
            <span
              className={`absolute top-[20px] w-[8rem] bg-gray-400 py-1 text-center font-semibold text-gray-600 ${i18n.language === "ar" ? "end-[-30px] rotate-[-45deg]" : "end-[-30px] -rotate-[-45deg]"
                }`}
            >
              {t("apps.inactive")}
            </span>
          )}
        </div>

        <div className="font-bold text-gray-500">{i18n.language === "en" ? app.titleEN : app.titleAR}</div>
        <p className="text-slate-500">{i18n.language === "en" ? app.descriptionEN : app.descriptionAR}</p>

        {app.static || WithoutPlan ? null : app.available === false ? null : app.installed ? (
          <div className="flex items-center justify-between">
            {/* uninstall app */}
            <button
              disabled={isPending}
              onClick={() => uninstallApp(app.name)}
              className="mt-1 self-end rounded-md bg-red-500 px-3 py-2 text-white disabled:cursor-not-allowed disabled:bg-gray-500 disabled:text-gray-300"
            >
              {t("loyaltyPointsApp.uninstall")}
            </button>

            {/* Modal Button */}
            <button
              disabled={isPending}
              onClick={() => setIsModalOpen(true)}
              className="mt-1 self-end rounded-md bg-sidebar px-3 py-2 text-skyblue disabled:cursor-not-allowed disabled:bg-gray-500 disabled:text-gray-300"
            >
              {t("loyaltyPointsApp.configure")}
            </button>
          </div>
        ) : (
          <button
            disabled={isPending}
            onClick={() => installApp(app.name)}
            className="self-end rounded-md bg-green-500 px-3 py-2 text-white disabled:cursor-not-allowed disabled:bg-gray-500 disabled:text-gray-300"
          >
            {t("loyaltyPointsApp.install")}
          </button>
        )}
      </div>
      {/* settings Modal */}

      {/* Modal */}
      {isModalOpen && (
        <div
          className="fixed inset-0 z-[9999] flex items-start justify-center bg-black/50 pt-[70px]"
          aria-labelledby="modal-title"
          role="dialog"
          aria-modal="true"
        >
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
            <div className="relative w-[85%] max-w-xl flex flex-col gap-3 rounded-lg bg-white px-4 py-3 pb-5 shadow-lg sm:px-5 sm:py-5 md:gap-7">
              <IoMdClose
                size={24}
                className="absolute end-2 top-2 cursor-pointer text-red-600"
                onClick={() => setIsModalOpen(false)}
              />
              <p className="text-sm text-gray-600 mt-5">
                {t("loyaltyPointsApp.description")}
              </p>
              {/* Points earned per 1 SAR */}
              <div className="flex gap-2 m-2">
                {/* Disabled "1 Riyal" input */}
                <div className="flex-1">
                  <label className="text-sm font-medium text-gray-700 block mb-1">
                    1 {t("loyaltyPointsApp.riyal")}
                  </label>
                  <input
                    type="number"
                    value="1"
                    disabled
                    className="w-full rounded border border-gray-300 px-1 py-2 text-sm shadow-sm bg-gray-100 cursor-not-allowed"
                  />
                </div>

                {/* Editable "Points" input */}
                <div className="flex-1">
                  <label className="text-sm font-medium text-gray-700 block mb-1">
                    {t("loyaltyPointsApp.points")}
                  </label>
                  <input
                    type="number"
                    min="0"
                    value={pointsPerRiyal}
                    onChange={(e) => setPointsPerRiyal(e.target.value)}
                    placeholder={t("loyaltyPointsApp.pointsPlaceholder")}
                    className="w-full rounded border border-gray-300 px-1 py-2 text-sm shadow-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                  />
                </div>
              </div>


              {/* Discount value of 1 point */}
              <div>

                <h1 className="text-sm font-medium text-gray-700">
                  {t("loyaltyPointsApp.discountPerPoint")}
                </h1>
                <div className="flex gap-2 m-2">
                  {/* Points input */}
                  <div className="flex-1">
                    <label className="text-sm font-medium text-gray-700 block mb-1">
                      {t("loyaltyPointsApp.points")}
                    </label>
                    <input
                      type="number"
                      min="0"
                      value={discountPoints}
                      onChange={(e) => setDiscountPoints(e.target.value)}
                      placeholder={t("loyaltyPointsApp.pointsPlaceholder")}
                      className="w-full rounded border border-gray-300 px-1 py-2 text-sm shadow-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                    />
                  </div>

                  {/* Riyal input */}
                  <div className="flex-1">
                    <label className="text-sm font-medium text-gray-700 block mb-1">
                      {t("loyaltyPointsApp.riyal")}
                    </label>
                    <input
                      type="number"
                      min="0"
                      value={discountRiyal}
                      onChange={(e) => setDiscountRiyal(e.target.value)}
                      placeholder={t("loyaltyPointsApp.discountPlaceholder")}
                      className="w-full rounded border border-gray-300 px-1 py-2 text-sm shadow-sm"
                    />

                  </div>
                </div>

              </div>

              <button
                onClick={submit}
                disabled={isPending}
                className="rounded-md bg-sidebar py-2 text-sm text-skyblue transition-colors duration-200 hover:bg-sidebar">
                {t("loyaltyPointsApp.submit")}
              </button>
            </div>
          </div>


        </div>
      )}
    </>
  );
}
export default LoyaltyPointsApp;
